import {
	INWARD_LINK_DIRECTION,
	OUTWARD_LINK_DIRECTION,
	BOTH_LINK_DIRECTION,
} from '@atlassian/jira-issue-shared-types/src/common/types/linked-issue-type.tsx';
import type { LinkIssueButtonAiOpsIncidentIssueLinkTypesQuery$data } from '@atlassian/jira-relay/src/__generated__/LinkIssueButtonAiOpsIncidentIssueLinkTypesQuery.graphql';
import type { UnmaskedResponseData } from '../types/issue-type.tsx';

type IssueLinkType = {
	id: string;
	label: string;
	direction:
		| typeof BOTH_LINK_DIRECTION
		| typeof INWARD_LINK_DIRECTION
		| typeof OUTWARD_LINK_DIRECTION;
};

type UnmaskedResponseDataWithQuery =
	| UnmaskedResponseData
	| LinkIssueButtonAiOpsIncidentIssueLinkTypesQuery$data;
export const transformAggResponseToIssueLinkTypes = (
	data: UnmaskedResponseDataWithQuery,
): IssueLinkType[] => {
	const edges = data.jira?.issueLinkTypes?.edges ?? [];

	const allIssueLinkTypes: IssueLinkType[] = [];
	return edges.reduce((issueLinkTypes, edge) => {
		if (!edge?.node || !edge.node) {
			return issueLinkTypes;
		}

		const { linkTypeId, inwards, outwards } = edge.node;

		if (inwards && inwards === outwards) {
			issueLinkTypes.push({
				id: linkTypeId || '',
				label: inwards,
				direction: BOTH_LINK_DIRECTION,
			});
		} else {
			issueLinkTypes.push({
				id: linkTypeId || '',
				label: inwards || '',
				direction: INWARD_LINK_DIRECTION,
			});
			issueLinkTypes.push({
				id: linkTypeId || '',
				label: outwards || '',
				direction: OUTWARD_LINK_DIRECTION,
			});
		}
		return issueLinkTypes;
	}, allIssueLinkTypes);
};
